<template>
  <div class="bar-container">
    <v-chart :options="barOptions" autoresize theme="light"></v-chart>
    <div>{{$t('Home.table1Desc')}}</div>
  </div>
</template>

<script>
import echarts from 'echarts';

export default {
  props: {
    chartDict: Object,
  },
  data() {
    // eslint-disable-next-line
    const dataAxis = ['xxx.com', 'yyy.com', 'zzz.com', 'aa.com', 'bbb.com', 'ccc.com', 'dddd.com', 'eeee.com', 'ffff.com', 'zzzz.com'];
    // eslint-disable-next-line
    const data = [220, 182, 191, 234, 290, 330, 310, 123, 442, 321, 90, 149, 210, 122, 133, 334, 198, 123, 125, 220];
    return {
      barOptions: {
        title: {
          text: '流量排行 TOP10 域名',
        },
        xAxis: {
          data: dataAxis,
          axisLabel: {
            textStyle: {
              color: '#A1A7C4',
              'font-family': 'Helvetica-Bold',
              'font-size': '12px',
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          z: 10,
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              'font-family': 'Helvetica-Bold',
              'font-size': '12px',
              color: '#A1A7C4',
            },
          },
        },
        series: [
          {
            type: 'bar',
            barWidth: '28px',
            itemStyle: {
              normal: {
                // 柱形图圆角，初始化效果
                barBorderRadius: [4, 4, 4, 4],
                color: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [
                    { offset: 0, color: '#87B7FF' }, // 柱图渐变色
                    { offset: 1, color: '#4F81FF' }, // 柱图渐变色
                  ],
                ),
              },
            },
            emphasis: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#87B7FF' }, // 柱图高亮渐变色
                  { offset: 1, color: '#4F81FF' }, // 柱图高亮渐变色
                ],
              ),
            },
            data,
          },
        ],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
  .bar-container {
    position: relative;
    .echarts {
      width: 100%;
      height: 100%;
    }
    :nth-child(2) {
      position: absolute;
      right: 20px;
      top: -10px;
      height: 20px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5A607F;
      letter-spacing: 0;
    }

  }
</style>
